<div class="mt-3">
  <div class="col-12">
    <div *ngIf="success" class="alert alert-success alert-dismissible fade show">
      {{ successMessage }}
      <button (click)="success = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <p-panel [toggleable]="true">
      <ng-template pTemplate="header">
        <span class="filter-title p-panel-title"><i class="fa fa-search"></i>Filter</span>
      </ng-template>
      <div class="row">
        <div class="col-2">
          <p-floatLabel>
            <input [(ngModel)]="dadSearchCriteria.companyOrBillingAccount" (ngModelChange)="setFilteredDadsList()" class="form-control"
                   id="companyOrBillingAccount" name="companyOrBillingAccount" type="text" pInputText>
            <label for="companyOrBillingAccount">
              Company or Billing account
            </label>
          </p-floatLabel>
        </div>
        <div class="col-2">
          <p-floatLabel>
            <p-calendar [(ngModel)]="dateFilterFrom" (ngModelChange)="resetDadsWithDate()" [disabledDays]="" dateFormat="mm/yy"
                        view="month"></p-calendar>
            <label>
              Usage month From
            </label>
          </p-floatLabel>
        </div>
        <div class="col-2">
          <p-floatLabel>
            <p-calendar [(ngModel)]="dateFilterTo" (ngModelChange)="resetDadsWithDate()" dateFormat="mm/yy"
                        view="month"></p-calendar>
            <label>Usage month To</label>
          </p-floatLabel>
        </div>
        <div class="col-2">
          <p-floatLabel>
            <p-multiSelect [(ngModel)]="dadSearchCriteria.exchanges" (ngModelChange)="setFilteredDadsList()"
                           [options]="exchangeNamesList" [style]="{'width':'100%'}"></p-multiSelect>
            <label>Exchange</label>
          </p-floatLabel>
        </div>
        <div class="col-2">
          <p-floatLabel>
            <p-multiSelect [(ngModel)]="dadSearchCriteria.status" (ngModelChange)="setFilteredDadsList()" [options]="statusOptions"
                           [style]="{'width':'100%'}"></p-multiSelect>
            <label>Form status</label>
          </p-floatLabel>
        </div>
        <div class="col-2">
          <div class="row">
            <div class="ml-auto mt-auto buttons-margin-left">
              <div class="d-flex mt-2">
                <div class="mr-2">
                  <button (click)="resetTable()" icon="fa fa-refresh pr-2" iconPos="left"
                          label="Reset" pButton style="margin-top: 20px; float: right;"
                          type="button"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-panel>
  </div>
  <div class="mt-3">
    <div class="col-12">
      <p-table #dataTable (sortFunction)="tableService.customSort($event)" [(selection)]="selectedDads" [columns]="cols" [customSort]="true"
               [paginator]="true" [rows]="20"
               [value]="filteredDads">
        <ng-template pTemplate="caption">
          <div class="p-helper-clearfix caption-buttons-container">
            <div class="float-left">
              <button (click)="exportDadFormPdfs()" class="btn btn-outline-primary button-size" type="reset">
                <i aria-hidden="true" class="fa fa-download pr-2"></i>
                Export all selected dad forms as PDF
              </button>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th>
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th *ngFor="let col of cols"
                [pSortableColumnDisabled]="!col.sortable"
                [pSortableColumn]="col.field"
                [width]="col.width" class="p-sortable-column ng-star-inserted">
              {{ col.header }}
            </th>
          </tr>
        </ng-template>
        <ng-template let-dad pTemplate="body">
          <tr>
            <td>
              <p-tableCheckbox [value]="dad"></p-tableCheckbox>
            </td>
            <td>
              <div>{{ dad?.createdAt | date: 'yyyy-MM-dd':'+1000' }}</div>
            </td>
            <td>
              <div style="overflow: hidden; text-overflow: ellipsis;">{{ dad?.companyName }}</div>
            </td>
            <td>
              <div>{{ dad?.billingAccountName }}</div>
            </td>
            <td>
              <div>{{ dad?.exchangeNameInTitle }}</div>
            </td>
            <td>
              <div>{{ dad?.status }}</div>
            </td>
            <td>
              <div>{{ dad?.usageMonth | date: 'yyyy-MM-01':'+8000' }}</div>
            </td>
            <td>
               {{ dad?.cutoff }}
            </td>
            <td>
              <div>{{ dad?.autoReport | autoReport }}</div>
            </td>
            <td>
              <div>{{ dad?.carriedForward === true ? 'Yes' : 'No' }}</div>
            </td>
            <td>
              <div>{{ dad?.reminderStatus }}</div>
            </td>
            <td style="min-width: 160px;">
              <div class="d-flex flex-column">
                <a *ngIf="this.canEditForm(dad)" class="btn btn-link no-padding-button"
                   routerLink="/dad-form/{{dad.uniqid}}">Edit form</a>
                <button (click)="downloadPdf(dad)" class="btn btn-link no-padding-button" type="button">
                  <span>Download PDF</span>
                </button>
                <a *ngIf="this.canSeeOriginalClientDeclaration(dad)" class="btn btn-link no-padding-button"
                   routerLink="/dad-form/{{dad.uniqid}}/original">See original client DAD form</a>
                <ng-container *ngIf="!dad?.isSelfReported && dad?.dadConfig?.canAutoReport">
                  <button (click)="alterAutoReport(dad)" *roles="['ROLE_MCKAY']" class="btn btn-link no-padding-button"
                          type="button">
                    <ng-container *ngIf="dad.autoReport">Disable auto-report</ng-container>
                    <ng-container *ngIf="!dad.autoReport">Enable auto-report</ng-container>
                  </button>
                </ng-container>
                <button *roles="['ROLE_MCKAY']" (click)="editBoxUrl(dad)" class="btn btn-link no-padding-button">
                  Edit link to Box
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div class="card flex justify-content-center" *roles="['ROLE_MCKAY']">
        <p-dialog header="Edit Link to box" [modal]="true" [(visible)]="boxUrlDialogVisible" [closeOnEscape]="true"
                  [style]="{ width: '40rem' }">
          <div class="flex align-items-center gap-3 mb-3">
            <div [ngClass]="{'p-invalid': true}">
              <input pInputText [ngClass]="{'p-invalid': true}"
                     [style]="this.boxUrlError ? 'color: red; border-color: red': ''"
                     id="boxUrl" autocomplete="off" style="width: 100%;" [(ngModel)]="currentBoxUrl" (ngModelChange)="removeError()"/>
              <small class="p-error" *ngIf="this.boxUrlError">URL must start with "https://mckay-brothers.app.box.com"</small>
            </div>
          </div>
          <div class="flex justify-content-end gap-2 pull-right">
            <p-button class="mr-2" label="Save" (onClick)="saveBoxUrl()"/>
            <p-button label="Cancel" severity="info" (onClick)="closeBoxUrl()"/>
          </div>
        </p-dialog>
      </div>
    </div>
  </div>
</div>
